export const INCIDENT_REVIEW_PHASES = [
  {
    title: 'Detected',
    detail: 'Understand the grouped context and confirm the event that triggered the incident.',
  },
  {
    title: 'Review',
    detail: 'Check evidence quality, detection logic, and system state before taking action.',
  },
  {
    title: 'Assign Action',
    detail: 'Choose the right response path and make ownership explicit.',
  },
  {
    title: 'Track Impact',
    detail: 'Review the recommended action path and complete the operational response.',
  },
  {
    title: 'Report',
    detail: 'Capture review history so the next incident starts from better context.',
  },
] as const;

export function reviewSeriesTimeLabel(value: unknown): string {
  const raw = String(value || '').trim();
  if (!raw) return 'Time pending';
  const ts = new Date(raw);
  if (Number.isNaN(ts.getTime())) return raw;
  return ts.toLocaleString([], {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
